import User from './UserDetailController';

export default User;
